const restaurant = {
  restaurant: "مطعم", // translated 
  restaurants: "مطاعم", // translated 
  category: "فئة", // translated 
  score: "نتيجة", // translated 
  priceQuartile: "ربع السعر", // translated 
  scoreLowestFirst: "النتيجة (الأدنى أولاً)", // translated 
  scoreHighestFirst: "النتيجة (الأعلى أولاً)", // translated 
  priceLowestFirst: "السعر (الأدنى أولاً)", // translated 
  priceHighestFirst: "السعر (الأعلى أولاً)", // translated 
  allPrices: "جميع الأسعار", // translated 
  reserve: "احتياطي", // translated 
  dining: "تناول الطعام", // translated 
};




export default restaurant;
